import { useQuery } from '@apollo/client';
import T from 'prop-types';
import React from 'react';

import Loader from '@skippay/core/components/Loader';
import Redirect from '@skippay/core/components/Redirect';
import { FormattedMessage } from '@skippay/core/i18n/intl';

import commonLabels from 'i18n/labels';
import MyProfileQuery from 'queries/MyProfileQuery.graphql';
import { hasMaxiPackage } from 'utils/currentUserUtils';

function RedirectAccountType(props) {
	const { data } = useQuery(MyProfileQuery);
	const redirectPath =
		data && (hasMaxiPackage(data.myProfile) ? props.maxiPackageTo : props.miniPackageTo);

	return redirectPath ? <Redirect to={redirectPath} /> : props.children;
}

RedirectAccountType.propTypes = {
	children: <Loader fullSize message={<FormattedMessage {...commonLabels['labels.loading']} />} />,
};

RedirectAccountType.propTypes = {
	miniPackageTo: T.string,
	maxiPackageTo: T.string,
	children: T.node,
};

export default RedirectAccountType;
